module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aNOKU"))).then(() => parcelRequire('dJXJK'));